import { Button, Card } from '@mui/material';
import React from 'react';

import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { FileDropZoneProps } from './types';
import useFileDropZoneStyles from './styles';

const FileDropZone: React.FunctionComponent<FileDropZoneProps> = (props) => {
  const { t } = useTranslation('common');
  const {
    accept,
    acceptedFiles,
    fileSize,
    rejectedFiles,
    multiple,
    label,
    dropZoneLabel,
    buttonProps,
    btnTextStyle,
  } = props;
  const classes = useFileDropZoneStyles();
  const { variant, color, size } = buttonProps.props;
  const { getRootProps, getInputProps, inputRef } = useDropzone({
    onDrop: (files: File[]) => {
      acceptedFiles?.(files);
      // allow reuploding of a file
      if (inputRef?.current?.value) {
        inputRef.current.value = '';
      }
    },
    accept: accept,
    maxSize: fileSize,
    onDropRejected: (files) => rejectedFiles?.(files),
    multiple: multiple,
  });

  const renderFileDropZone = () => {
    return (
      <>
        <Card className={classes.wrapper}>
          <div {...getRootProps({ className: 'dropzone' })} className={classes.dropZoneWrapper}>
            <div>{dropZoneLabel}</div>
            <div className={classes.or}>{t('or')}</div>
            <div
              onClick={(event) => {
                event.stopPropagation();
              }}
            >
              <Button
                variant={variant}
                component='label'
                color={color}
                size={size}
                className={btnTextStyle}
              >
                {label}
                <input {...getInputProps()} multiple />
              </Button>
            </div>
          </div>
        </Card>
      </>
    );
  };

  return renderFileDropZone();
};

export default FileDropZone;
